import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';

export interface DashboardStats {
  total_jobs: number;
  jobs_this_week: number;
  jobs_this_month: number;
  total_value: number;
  total_contacts: number;
  contacts_this_week: number;
}

export interface StatusBreakdownItem {
  board_status__name: string;
  board_status__order: number;
  count: number;
  percentage: number;
}

export interface BoardInfo {
  id: number;
  name: string;
}

export interface DashboardData {
  stats: DashboardStats;
  job_boards: BoardInfo[];
  job_status_breakdown: Record<string, StatusBreakdownItem[]>;
  opportunity_boards: BoardInfo[];
  opportunity_pipeline_breakdown: Record<string, StatusBreakdownItem[]>;
}

export const useDashboardData = () => {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async (): Promise<DashboardData> => {
      const response = await apiClient.get<DashboardData>('/api/dashboard/');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};